import { MatsuriFormsMultilineTextQuestionProps } from "matsuri-forms-sdk";
import { MultipleTextField } from "matsuri-ui";

export const MultipleTextQuestion = (
  props: MatsuriFormsMultilineTextQuestionProps,
) => {
  return (
    <MultipleTextField
      label="問題や提案について説明してください"
      required={props.required}
      name={props.name}
      rows={6}
      helperText="現在開いているページのURLは自動的に送信されるため記載不要です"
    />
  );
};
